import { RouteObject } from 'react-router-dom'

import { default as Subscription } from '.'
import { PageLayout } from '../../../common/app'

export const subscriptionRoutes: RouteObject[] = [
  {
    path: '/settings/subscription/:id',
    element: (
      <PageLayout
        title="Manage Payment Details"
        htmlTitleOnly
        alignMainContent="center"
      >
        <Subscription.Subscription.Component />
      </PageLayout>
    ),
    loader: Subscription.Subscription.Loader,
  },
]
